import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CheckPermissions, GetQuery, PostQuery } from './Shared';

interface ItemFormulaListItem {
    id: number;
    name: string;
    installFormula: number;
    pickupFormula: number;
    formula: string;
    twoPplExampleFormatted: string;
    twoPplExampleTimeFormatted: string;
    threePplExampleFormatted: string;
    threePplExampleTimeFormatted: string;
    isDirty: boolean;
}

const ItemFormulaData = () => {
    let navigate = useNavigate();
    const [itemFormulas, setItemFormulas] = React.useState<ItemFormulaListItem[]>([]);
    const [loading, setLoading] = React.useState(false);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("CreateEditAdminLists");
        if (hasPermission) {
            getAdminFormulas();
        } else {
            navigate("/accessdenied");
        }
    }

    const getAdminFormulas = async () => {
        const apiUrl = "GetItemFormulas";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setItemFormulas(result.data.itemFormulas);
            setLoading(false);
        }
    }

    const handleInstallCellChange = (e: any, itemIndex: number) => {
        e.preventDefault();

        setItemFormulas(prevState => prevState.map((item, index) =>
            index == itemIndex ? { ...item, installFormula: Number(e.target.value), isDirty: true } : item
        ));
        setErrors({});
    }

    const handlePickupCellChange = (e: any, itemIndex: number) => {
        e.preventDefault();

        setItemFormulas(prevState => prevState.map((item, index) =>
            index == itemIndex ? { ...item, pickupFormula: Number(e.target.value), isDirty: true } : item
        ));
        setErrors({});
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        var itemList = [...itemFormulas.filter(i => i.isDirty)];

        var rowNumber = 0;
        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < itemList.length; i++) {
            rowNumber += 1;
            var newErrorString = "";

            if (itemList[i].installFormula < 0.01) {
                newErrorString += "Install Formula > 0, ";
                error = true;
            }

            if (itemList[i].pickupFormula < 0.01) {
                newErrorString += "Pickup Formula > 0, ";
                error = true;
            }

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }

        }
        if (error) {
            formIsValid = false;
            errorList["items"] = errorString;
        }
        setErrors(errorList);
        
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            var changed = [...itemFormulas.filter(p => p.isDirty)];

            if (changed.length === 0) {
                toast.info("No items have changed.");
            } else {
                saveItemFormulas(changed);
            }
        } else {
            toast.error("Please fix validation errors before Saving")
        }
    }

    const saveItemFormulas = async (changed: ItemFormulaListItem[]) => {
        var saveFormulas = {
            itemFormulas: changed
        };

        var jsonItem = JSON.stringify(saveFormulas);

        const apiUrl = "SaveItemFormulas";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Item Formulas Saved Successfully");
                getAdminFormulas();
            }
        }
    }

    const renderDetails = (
        <div>
            <div>Void Example: Installing 1 Void</div>
            <div>Other Example: Installing 40 Quantity</div>

            <div>
                <div className="overflowAuto">
                    <table className="table tableColours">
                        <thead>
                            <tr>
                                <th className="hidden">Id</th>
                                <th>Name</th>
                                <th>Install Formula</th>
                                <th>Dismantle Formula</th>
                                <th>Total Minutes Formula</th>
                                <th>2 Person Eg (mins)</th>
                                <th>2 Person Eg (hh:mm)</th>
                                <th>3 Person Eg (mins)</th>
                                <th>3 Person Eg (hh:mm)</th>
                            </tr>
                        </thead>
                        {itemFormulas.map((item, index) =>
                            <tbody key={item.id}>
                                <tr>
                                    <td className="hidden">{item.id}</td>
                                    <td className="table__text--align">{item.name}</td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="installFormula" name="installFormula" value={item.installFormula} onChange={(e) => handleInstallCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' min="0" step="0.01" className='form-control textalignright' id="pickupFormula" name="pickupFormula" value={item.pickupFormula} onChange={(e) => handlePickupCellChange(e, index)} />
                                    </td>
                                    <td className="table__text--align">{item.formula}</td>
                                    <td className="table__text--align">{item.twoPplExampleFormatted}</td>
                                    <td className="table__text--align">{item.twoPplExampleTimeFormatted}</td>
                                    <td className="table__text--align">{item.threePplExampleFormatted}</td>
                                    <td className="table__text--align">{item.threePplExampleTimeFormatted}</td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                    {errors["items"] ?
                        (errors["items"]).split("\n").map((item: any, key: any) => {
                            return <span className="label errors" key={key}>{item}<br /></span>
                        })
                        : ""}
                </div>
                <button className="defaultbutton defaultbutton__large marginBottom10" type="button" onClick={save} disabled={loading}>Save</button>
            </div>

        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return <div>
        <h1>Item Formulas</h1>
        {contents}
    </div>;

}

export default ItemFormulaData;